import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Accordion, AccordionTab } from 'primereact/accordion';
import Loader from '../../components/Loader'; 
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';

const RoleForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(false);
    const [name, setName] = useState('');
    const [permissions, setPermissions] = useState([]);

    useEffect(() => {
        getPermissions();
    }, []);

    const getPermissions = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: 'GET',
                url: `role-permissions/${id || ''}`,
            });
            const data = response.data;
            if (data.status) {
                setName(data.data.role?.name || '');
                // console.log(data.data.permissions);
                setPermissions(data.data.permissions);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
            console.error(error);
        }
    };

    const toggleCheck = (id) => {
        const updatedPermissions = permissions.map((perm) =>
            perm.id === id ? { ...perm, isChecked: !perm.isChecked } : perm
        );
        setPermissions(updatedPermissions);
    };

  
    const submitForm = async (e) => {
        e.preventDefault();
        setIsLoader(true);
        try {
            const response = await ApiService.request({
                method: 'POST',
                url: `roles/createOrUpdate/${id || ''}`,
                data: { name, permissions },
            });
            const data = response.data;
            if (data.status) {
                toast.success(data.message);
                navigate('/roles');
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            console.error('Submission failed:', error);
            setIsLoader(false);
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                            {id ? 'Edit' : 'Add New'} Role
                        </h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/dashboard" className="text-muted text-hover-primary">
                                    Dashboard
                                </Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">
                                <Link to="/roles" className="text-muted text-hover-primary">
                                    Roles
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="card">
                        <div className="card-body pt-0">
                            <form id="kt_modal_new_target_form" onSubmit={submitForm}>
                                <div className="row g-9 my-3">
                                    <div className="col-md-12 fv-row fv-plugins-icon-container">
                                        <label className="required fs-6 fw-semibold mb-2">Name</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-solid"
                                            placeholder="Enter Role Name"
                                            required
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <hr />
                                <h4 className="py-3 my-3">Permissions:</h4>
                                    {permissions && permissions.map((tab, index) => (
                                        <h5 className='my-4 bg-light p-3 border rounded form-check' >
                                          <label className='form-check-label text-dark ms-10'>
                                            <input
                                                type="checkbox"
                                                onChange={() => toggleCheck(tab.id)}
                                                id={`perm-parent-${index}`}
                                                className="form-check-input me-3"
                                                checked={tab.isChecked || false}
                                            />
                                            {tab.name}
                                        </label>
                                        </h5>
                                       
                                    ))}
                                <div className="row g-9 my-3">
                                    <div className="text-center">
                                        <Link to="/roles" id="kt_modal_new_target_cancel" className="btn btn-light me-3">
                                            Back
                                        </Link>
                                        <button type="submit" className="btn btn-base" disabled={isLoader}>
                                            {isLoader ? <Loader size={20} text="Submitting" /> : 'Submit'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoleForm;